/**
 * @file
 * Patria brand book menu.
 */

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.brand_book_menu = {
    attach: () => {

      const brandBookSidebarCollapser = ".brand-book-sidebar-collapser .collapse-button";
      const brandBookSidebar = ".brand-book-container__sidebar";

      const brandBookMenu = "#block-patria-brand-book-menu";
      const brandBookMenuAnonymous = "#block-patria-brand-book-menu-anonymous";

      $(brandBookSidebarCollapser).click(function () {
        $(this).toggleClass('sidebar-open');
        $(this).parent().toggleClass('sidebar-open');
        $(brandBookSidebar).toggleClass('open');
        $(document.body).toggleClass('noscroll');
      });

      // Add active class to toggle on click.
      $(brandBookMenu + ' .sub-menu-toggle,' + brandBookMenuAnonymous + ' .sub-menu-toggle').click(function () {
        $(this).toggleClass('menu-open');
        $(this).siblings('.menu').toggleClass('open');
      });

      // If on submenu page, open current sub menu by default
      $(document).ready(function () {
        const currentMenuItem = ".brand-book-container__sidebar .menu-item--expanded.menu-item--active-trail";
        const currentMenuItemLink = currentMenuItem + ">a";
        const currentMenuItemButton = currentMenuItem + ">.sub-menu-toggle";
        const currentMenuItemSubmenu = currentMenuItem + ">.menu";

        if (!$(currentMenuItemLink).hasClass('is-active')) {
          $(currentMenuItemButton).addClass('menu-open');
          $(currentMenuItemSubmenu).addClass('open');
        }
      });
    }
  };

})(jQuery, Drupal);
